import { Injectable } from '@angular/core';
import { Result } from '../../shared/result';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { CommonModel } from 'src/app/shared/common-model';
import { pageload } from 'src/app/shared/pageload-model';


@Injectable({
  providedIn: 'root'
})
export class PlanjourneyService {
  getLan: string;
  data: any;
  public Token: string;
  obj = new CommonModel;
  timeobj = new pageload;


  constructor(private http: HttpClient) {
    var token = LocalstorageService.getLocal('Token');
    this.getLan = LocalstorageService.getLanguage('language');
    this.obj.lan = LocalstorageService.getLanguage('language');
    this.timeobj.pageid = 8;
    this.timeobj.pagename = 'Plan Journey';
     this.timeobj.loadingtime = Number( LocalstorageService.getPageLoadTime("planjourney"));
     if(token != null && token != "" && token!= undefined && !LocalstorageService.TokenExpired(token)){
     this.timeobj.Token = LocalstorageService.getLocal('Token');
     }



    // this.data = JSON.parse(localStorage.getItem('currentUser'));
    // this.Token = LocalstorageService.getLocal('Token');

    // if(this.data != null)
    //   this.Token = this.data.token;
  }

  public InitHeader() {
    let headers;
    if(this.Token) {
      headers = { 'Authorization': 'Bearer ' + this.Token,
      'Content-Type': 'application/json'  };
    }
    return headers;
  }

  public GetAllLocations() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/ListofLocations/GetLocations_V1`, this.obj);
  }

  public GetScheduleData(sourceid,destinationid,journeytime) {
    //debugger;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/SearchByLocation/getConnectedRoutes_V1?sourceId=` + sourceid +`&destination=` + destinationid +`&JourneyTime=` + journeytime + `&lan=` + this.getLan ,null);
  }

  public GetTripDetails(tripid) {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/SearchByLocation/GetTripDetails_V1?tripid=` + tripid +`&lan=` + this.getLan, null);
  }

  public GetCurrentLocation(vehicleid) {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/SearchByLocation/getcurrentlocation?vehicleid=` + vehicleid +`&lan=` + this.getLan, null);
  }

  public GetRouteWayPoints(routeid) {
    // let headers;
    // headers = this.InitHeader();
    return this.http.get<Result>(`${environment.apiUrl}/SearchByLocation/GetRouteWayPoints?routeid=` + routeid);
  }

  public GetRouteWayPointsGis(routeid) {
    // let headers;
    // headers = this.InitHeader();
    return this.http.get<Result>(`${environment.apiUrl}/SearchByLocation/GetRouteWayPointsGis?routeid=` + routeid);
  }
  public pageLoadTimeInsert() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/InsertPageLoaedTimeData`, this.timeobj);
  }

  public GetFareDetails(data) {
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/TickectPurchase_V1/GetFareDetails` ,data);
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/KDMC_MobileAPI/TickectPurchase_V1/GetFareDetails` ,data,{ headers,withCredentials:true });

  }
  public InsertTicket(data) {
    debugger;
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/TickectPurchase_V1/InsertPurchaseTicket`, data);
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/KDMC_MobileAPI/TickectPurchase_V1/InsertPurchaseTicket`, data),{ headers,withCredentials:true };
  }

}
